// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as PorterStoreOrderApiModel from "../api-model/PorterStoreOrderApiModel.bs.js";

function decodeRequester(data) {
  var detailsName = Belt_Option.flatMap(data.details, (function (d) {
          return d.name;
        }));
  var detailsPhone = Belt_Option.flatMap(data.details, (function (d) {
          return d.phone;
        }));
  var match = data.name;
  var match$1 = data.phone;
  return {
          user_id: data.user_id,
          persona: data.persona,
          name: match !== undefined ? data.name : detailsName,
          phone: match$1 !== undefined ? data.phone : detailsPhone
        };
}

function decodeOrder(data) {
  return {
          order_uuid: data.order_uuid,
          order_number: data.order_number,
          status: data.status,
          crm_status: data.crm_status,
          geo_region_id: data.geo_region_id,
          total_amount_minor: data.total_amount_minor,
          currency_code: data.currency_code,
          requester: Belt_Option.map(data.customer, decodeRequester),
          created_at: data.created_at,
          updated_at: data.updated_at
        };
}

function execute(json) {
  var response = DeccoUtils$Catalyst.resolveResult(PorterStoreOrderApiModel.t_decode(json), "PorterStoreOrderEntityMapper.res");
  return Belt_Array.map(response.orders, decodeOrder);
}

export {
  decodeRequester ,
  decodeOrder ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
